import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProducts } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/Seo";
import { ProductCard } from "@/components/ProductCard";
import { Heart } from "lucide-react";

export default function Favorites() {
  const { favorites } = useStore();
  const { user } = useAuth();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    getProducts({ limit: 60 }).then((all) => {
      setProducts(all.filter((p) => favorites.includes(p.slug)));
    }).catch(() => {});
  }, [favorites]);

  return (
    <>
      <Seo title="Favoriler" path="/favoriler"  noindex />
      <div className="container-shule py-10 lg:py-16">
        <h1 data-testid="favorites-title" className="font-serif text-4xl lg:text-5xl text-shule-coffee">Favorilerin</h1>
        {products.length === 0 ? (
          <div data-testid="favorites-empty" className="py-20 text-center">
            <Heart className="w-10 h-10 mx-auto text-shule-oak" />
            <p className="mt-4 font-serif text-2xl text-shule-mocha">Henüz favori parçan yok</p>
            <p className="text-sm text-shule-soft mt-2">{user ? "Beğendiğin ürünler hesabınla birlikte saklanır." : "Beğendiğin ürünler bu cihazda saklanır. Giriş yaptığında hesabındaki favorilerle birleştirilir."}</p>
            <Link to="/kategori/tumu" data-testid="favorites-browse-button" className="btn-primary-shule mt-6">Ürünleri Keşfet</Link>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
          </div>
        )}
      </div>
    </>
  );
}
